/* unplugin-vue-components disabled */import __unplugin_components_5 from '/home/pedrazzi/projetos/advogados/v5/src/components/Top.vue';
import __unplugin_components_4 from '/home/pedrazzi/projetos/advogados/v5/src/components/Top.vue';
import __unplugin_components_3 from '/home/pedrazzi/projetos/advogados/v5/src/components/Top.vue';
import __unplugin_components_2 from '~icons/mdi/email';
import __unplugin_components_1 from '~icons/mdi/phone-classic';
import __unplugin_components_0 from '~icons/mdi/whatsapp';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-img",
        {
          staticClass: "px-4",
          attrs: {
            height: _vm.height,
            src: "src/fotos/configurations/" + _vm.image,
            "lazy-src": "src/fotos/configurations/" + _vm.image,
            gradient: "to top right, rgba(0,0,0,.45), rgba(0,0,0,.2)",
            flat: "",
            dark: "",
            tile: "",
          },
        },
        [_vm._t("header")],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "py-4",
          attrs: { flat: "", tile: "", dark: "", color: _vm.color.secondary },
        },
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass:
                    "text-center text-sm-right text-h5 col-12 col-sm-6",
                  class: { "pb-0": !_vm.$vuetify.breakpoint.smAndUp },
                },
                [_vm._v("Contate-nos")]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "text-center text-sm-left col-12 col-sm-6",
                  class: { "pt-0": !_vm.$vuetify.breakpoint.smAndUp },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "aria-label": "whatsapp",
                        icon: "",
                        "x-large": "",
                        href: _vm.openWhats(),
                        target: "_blank",
                      },
                    },
                    [
                      _c(__unplugin_components_0, {
                        staticStyle: { "font-size": "40px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        title: "Telefone",
                        icon: "",
                        "x-large": "",
                        href: "tel:" + _vm.site.fone,
                      },
                    },
                    [
                      _c(__unplugin_components_1, {
                        staticStyle: { "font-size": "40px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        title: "Contato",
                        icon: "",
                        "x-large": "",
                        href: "contato",
                      },
                    },
                    [
                      _c(__unplugin_components_2, {
                        staticStyle: { "font-size": "40px" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(__unplugin_components_3, { attrs: { color: _vm.color.primary } }, [
        _c("h2", { staticClass: "font-italic font-weight-black text-h4" }, [
          _vm._v("\n      Horário de Atendimento\n    "),
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("Confira nosso horário de atendimento")]),
      ]),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-card",
            {
              staticClass: "mt-6 mb-4 mx-auto pa-0",
              attrs: { "max-width": "400", flat: "" },
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "pa-0",
                  attrs: {
                    text: "",
                    color: _vm.$vuetify.theme.isDark
                      ? "grey lighten-4"
                      : "grey darken-4",
                  },
                },
                [
                  _c("v-simple-table", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c(
                              "tbody",
                              _vm._l(_vm.list, function (item, idx) {
                                return _c(
                                  "tr",
                                  {
                                    key: idx,
                                    class: {
                                      active: item.status,
                                      transp: !item.status,
                                      "font-weight-black": item.status,
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "px-2 align-middle text-capitalize",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.status
                                      ? _c(
                                          "td",
                                          {
                                            staticClass:
                                              "px-1 align-middle text-center",
                                          },
                                          _vm._l(
                                            item.times,
                                            function (time, _idx) {
                                              return _c("span", { key: _idx }, [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(time.start) +
                                                    "-" +
                                                    _vm._s(time.end) +
                                                    "\n                    "
                                                ),
                                                item.times.length > 1 &&
                                                _idx < 1
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "mx-2" },
                                                      [
                                                        _vm._v(
                                                          "\n                      e\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-middle text-center",
                                          },
                                          [_vm._v("Fechado")]
                                        ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "pa-0 mb-8 mx-auto",
              attrs: { "max-width": "400", flat: "" },
            },
            [
              _vm.site.whatsapp
                ? _c(
                    "btn-whatsapp",
                    {
                      attrs: {
                        block: "",
                        large: "",
                        dark: "",
                        color: "success darken-2",
                      },
                    },
                    [_vm._v("Fale conosco")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(__unplugin_components_4, { attrs: { color: _vm.color.primary } }, [
        _c("h2", { staticClass: "font-italic font-weight-black text-h4" }, [
          _vm._v("Nossa Localização"),
        ]),
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.site.end + " - " + _vm.site.city + "-" + _vm.site.state
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "mb-6 py-lg-10 py-4 text-center" },
          [
            _c("street-view-panorama", {
              staticClass: "mt-3",
              attrs: { site: _vm.site },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(__unplugin_components_5, { attrs: { color: _vm.color.primary } }, [
        _c("h2", { staticClass: "font-italic font-weight-black text-h4" }, [
          _vm._v("Contato"),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("Entre em contato conosco através do formulário abaixo"),
        ]),
      ]),
      _vm._v(" "),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "mt-4 mb-8 py-3 mx-2" },
          [
            _c(
              "v-form",
              {
                ref: "form",
                attrs: { id: "form-contact", "lazy-validation": _vm.lazy },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.validate.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              },
              [
                _c("v-text-field", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    dense: "",
                    rules: _vm.rules.name,
                    label: "Nome",
                    placeholder: "Seu nome",
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    dense: "",
                    rules: _vm.rules.email,
                    label: "E-mail",
                    placeholder: "Seu email",
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    rules: _vm.rules.message,
                    label: "Mensagem",
                    placeholder: "Sua mensagem",
                  },
                  model: {
                    value: _vm.form.message,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "message", $$v)
                    },
                    expression: "form.message",
                  },
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-4",
                    attrs: {
                      form: "form-contact",
                      type: "submit",
                      title: "enviar email",
                      block: "",
                      dark: "",
                      color: "error darken-1",
                    },
                  },
                  [_vm._v("\n          enviar email\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }